import { createSlice } from '@reduxjs/toolkit';

type InitialState = {
  emergencyContacts: Contact[];
}

export type Contact = {
  id: number | null;
  first_name: string;
  last_name: string;
  relationship: string;
  username: string;
  email: string;
  phone_number: string;
  type: string;
}

const initialState: InitialState = {
  emergencyContacts: [
    {
      id: null,
      first_name: '',
      last_name: '',
      relationship: '',
      username: '',
      email: '',
      phone_number: '',
      type: ''
    }
  ]
};

const customizeSlice = createSlice({
  name: "customizeOptions",
  initialState,
  reducers: {
    setEmergencyContactList: (state, { payload }) => {
      state.emergencyContacts = [...payload];
    },
    updateEmergencyContactList: (state, { payload }) => {

      const index = state.emergencyContacts.findIndex(el => el.id === payload.id);

      if (index !== -1) {
        state.emergencyContacts = state.emergencyContacts.map(contact =>
          contact.id === payload.id ? { ...contact, ...payload } : contact
        );
      } else {
        state.emergencyContacts = [...state.emergencyContacts, payload];
      }
    },
    deleteContactFromList: (state, { payload }) => {
      state.emergencyContacts = state.emergencyContacts.filter(contact => contact.id !== payload.id);
    }
  },
});

export const { updateEmergencyContactList, setEmergencyContactList, deleteContactFromList } = customizeSlice.actions;

export default customizeSlice.reducer;
